import { Component, Prop, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class MobileFilters extends ThemeComponent {

    init() {

    }
}
